export const collapsedColWidth = '3.5rem';
export const expandedColWidth = '19rem';
